export default "__VITE_ASSET__D1xFef86__"